function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: inline-block;\n  overflow: hidden;\n  background-color: var(--theme-paper-hover, #f9fafb);\n  border-radius: 0.5rem;\n  \n  ",
        "\n\n  .dark & {\n    background-color: var(--theme-paper-hover, #374151);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: opacity 0.3s ease-in-out;\n  opacity: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--theme-paper-hover, #f9fafb);\n  opacity: ",
        ";\n  transition: opacity 0.3s ease-in-out;\n  pointer-events: none;\n\n  .dark & {\n    background-color: var(--theme-paper-hover, #374151);\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  width: 1.5rem;\n  height: 1.5rem;\n  border: 2px solid var(--theme-border, #e5e7eb);\n  border-top: 2px solid var(--theme-primary, #10b981);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n\n  .dark & {\n    border-color: var(--theme-border, #374151);\n    border-top-color: var(--theme-primary, #10b981);\n  }\n\n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  color: var(--theme-text-secondary, #6b7280);\n  font-size: 0.875rem;\n  text-align: center;\n  padding: 1rem;\n\n  .dark & {\n    color: var(--theme-text-secondary, #9ca3af);\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useState, useRef, useEffect } from 'react';
import styled from '@emotion/styled';
var ImageContainer = styled.div(_templateObject(), function(props) {
    return props.aspectRatio && "\n    aspect-ratio: ".concat(props.aspectRatio, ";\n  ");
});
var Image = styled.img(_templateObject1(), function(props) {
    return props.loaded ? 1 : 0;
});
var Placeholder = styled.div(_templateObject2(), function(props) {
    return props.loaded ? 0 : 1;
});
var LoadingSpinner = styled.div(_templateObject3());
var ErrorPlaceholder = styled.div(_templateObject4());
var LazyImage = function(param) {
    var src = param.src, alt = param.alt, className = param.className, style = param.style, aspectRatio = param.aspectRatio, placeholder = param.placeholder, errorPlaceholder = param.errorPlaceholder, onLoad = param.onLoad, onError = param.onError, onClick = param.onClick, _param_rootMargin = param.rootMargin, rootMargin = _param_rootMargin === void 0 ? '50px' : _param_rootMargin, _param_threshold = param.threshold, threshold = _param_threshold === void 0 ? 0.1 : _param_threshold;
    var _useState = _sliced_to_array(useState(false), 2), loaded = _useState[0], setLoaded = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), error = _useState1[0], setError = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), inView = _useState2[0], setInView = _useState2[1];
    var imgRef = useRef(null);
    var containerRef = useRef(null);
    // Set up Intersection Observer
    useEffect(function() {
        var observer = new IntersectionObserver(function(param) {
            var _param = _sliced_to_array(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                setInView(true);
                observer.disconnect();
            }
        }, {
            rootMargin: rootMargin,
            threshold: threshold
        });
        if (containerRef.current) {
            observer.observe(containerRef.current);
        }
        return function() {
            return observer.disconnect();
        };
    }, [
        rootMargin,
        threshold
    ]);
    // Image load handler
    var handleImageLoad = function() {
        setLoaded(true);
        if (onLoad) {
            onLoad();
        }
    };
    // Image error handler
    var handleImageError = function() {
        setError(true);
        if (onError) {
            onError();
        }
    };
    // Default error placeholder
    var defaultErrorPlaceholder = /*#__PURE__*/ React.createElement(ErrorPlaceholder, null, /*#__PURE__*/ React.createElement("div", {
        style: {
            fontSize: '1.5rem'
        }
    }, "\uD83D\uDDBC️"), /*#__PURE__*/ React.createElement("div", null, "Failed to load image"));
    // Default loading placeholder
    var defaultPlaceholder = /*#__PURE__*/ React.createElement(LoadingSpinner, null);
    return /*#__PURE__*/ React.createElement(ImageContainer, {
        ref: containerRef,
        className: className,
        style: style,
        aspectRatio: aspectRatio,
        onClick: onClick
    }, inView && !error && /*#__PURE__*/ React.createElement(Image, {
        ref: imgRef,
        src: src,
        alt: alt,
        loaded: loaded,
        onLoad: handleImageLoad,
        onError: handleImageError
    }), /*#__PURE__*/ React.createElement(Placeholder, {
        loaded: loaded && !error
    }, error ? errorPlaceholder || defaultErrorPlaceholder : placeholder || defaultPlaceholder));
};
export default LazyImage;
